// extracted by mini-css-extract-plugin
module.exports = {"button":"button_button__2JUdx","textonly":"button_textonly__3ADhC","empty":"button_empty__Pq6OD","border":"button_border__2DHUK"};